export const propertyImages = {
  image_404: 'assets/img/404_image.svg',
  link_icon: 'assets/new-img/link.svg',
  building_icon: 'assets/img/graphics/building.svg',
  eye_icon: 'assets/img/eye.svg',
  document_icon: 'assets/img/17-document.svg',
  laptop_icon: 'assets/img/laptop.svg',
  properties_icon: 'assets/img/graphics/Properties.svg',
  listing_lead_icon: 'assets/img/listing-lead.svg',
  listing_task: 'assets/img/listing-task.svg',
  listing_related: 'assets/img/listing-related.svg',
  approval_icon: 'assets/img/approvals.svg',
  listing_history: 'assets/img/listing-history.svg',
  calendar_minus: 'assets/img/calendar-minus.svg',
  left_arrow: 'assets/img/left-arrow.svg',
  right_arrow: 'assets/img/right-arrow.svg',
  related_contact: 'assets/img/graphics/related-contact.svg',
  comments_icon: 'assets/img/comments.svg',
  open_home_icon: 'assets/img/lead-overview/open_home.svg',
  auction_icon: 'assets/img/lead-overview/auction.svg',
  listing_1_icon: 'assets/menu-customisation-icons/Listing/listing1.svg',
  listing_2_icon: 'assets/menu-customisation-icons/Listing/listing2.svg',
  listing_3_icon: 'assets/menu-customisation-icons/Listing/listing3.svg',
  listing_4_icon: 'assets/menu-customisation-icons/Listing/listing4.svg',
  listing_5_icon: 'assets/menu-customisation-icons/Listing/listing5.svg',
  listing_6_icon: 'assets/menu-customisation-icons/Listing/listing6.svg',
  listing_7_icon: 'assets/menu-customisation-icons/Listing/listing7.svg',
  listing_8_icon: 'assets/menu-customisation-icons/Listing/listing8.svg',
  listing_9_icon: 'assets/menu-customisation-icons/Listing/listing9.svg',
};
